import React from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { withLayout } from "../../components/layout/Layout";
import { withPageName } from "../../components/layout/horizontalMenu/PageName";
import { Desktop, TabletMobile } from "../../hocs/Responsive";
import { SingleRoamingDevicesTable } from "./singleRoamingDevicesTable/SingleRoamingDevicesTable";
import { AriaPageTitle } from "../../components/ariaPageTitle";
import { SpsonBanner } from "./spsonBanner/SpsonBanner";

import "./SpsonPage.scss";

const SpsonPageContent = () => {
  return (
    <section className={"spson-page"}>
      <AriaPageTitle pageKey="page_title_spson_page" />
      <h1 className={"spson-page__title"}>
        <FormattedMessage id={"spson"} />
      </h1>
      <div className={"spson-page__content"}>
        <Desktop>
          <div className={"spson-page__content--left"}>
            <SpsonDescription />
            <SingleRoamingDevicesTable />
          </div>
          <div className={"spson-page__content--right"}>
            <SpsonBanner isMobileView />
          </div>
        </Desktop>
        <TabletMobile>
          <SpsonDescription />
          <SpsonBanner />
          <SingleRoamingDevicesTable />
        </TabletMobile>
      </div>
    </section>
  );
};

const SpsonPageTitle = () => {
  return (
    <h1>
      <FormattedMessage id={"spson"} />
    </h1>
  );
};

const SpsonDescription = () => {
  return (
    <div className={"spson-page__description"}>
      <p>
        <FormattedMessage id={"spson_description_1"} />
      </p>
      <p>
        <FormattedMessage id={"spson_description_2"} />
      </p>
    </div>
  );
};

export const SpsonPage = _.flow(
  withLayout(),
  withPageName(SpsonPageTitle())
)(SpsonPageContent);
